import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {makeAutoObservable, observable} from "mobx";
import {Bindings} from "data/constants/bindings";
import type {ILocalizationStore} from "data/stores/localization/localization.store";

export interface ICookieBannerController extends ViewController {
	get i18n(): ILocalizationStore;

	get isViewed(): boolean;

	closeBanner: () => void;
}

@injectable()
export class CookieBannerController implements ICookieBannerController {
	@observable _isViewed: boolean = Boolean(
		JSON.parse(localStorage.getItem("acceptedCookie") || "null")
	);

	constructor(@inject(Bindings.LocalizationStore) private _i18nStore: ILocalizationStore) {
		makeAutoObservable(this);
	}

	get i18n() {
		return this._i18nStore;
	}

	get isViewed(): boolean {
		return this._isViewed;
	}

	closeBanner = () => {
		this._isViewed = true;
		localStorage.setItem("acceptedCookie", "1");
	};

	dispose() {
		return;
	}

	init(param: void) {
		return;
	}
}
